import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                ninventario: {
                    search: `${codeAPI}/patrimony/search?q=:ninventario&match=1`,
                },
                acl: {
                    view: 'PIM_00001',
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PIM_00006',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layers: {
                active: true,
                title: 'Camadas',
                label: 'Camadas',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PIM_00002',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PIM_00007',
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    },{
                        'id': 'pim-patrimony',
                        'name': 'Património Municipal',
                        'url': `${codeAPI}/patrimony/search`,
                        'labelTemplate': '${inventory_num} - ${finances_num}',
                        'listTemplate': 'Nº Inventário: ${inventory_num}<br />Art. Cadastral: ${finances_num}',
                        'listGroup': 'type',
                        'placeholder': 'Património Municipal...',
                        'limit': 50,
                    },{
                        'id': 'pim-urbanism',
                        'name': 'Urbanismo',
                        'url': `portal/front/search/urbanism`,
                        'labelTemplate': '${label}',
                        'listTemplate': '${name}',
                        'listGroup': 'type',
                        'placeholder': 'Urbanismo...',
                        'ACL': 'GP_S_URB_10001',
                        'limit': 50,
                    },{
                        'id': 'pim-cartography',
                        'name': 'Cadastro Rústico',
                        'url': `portal/front/search/cartography`,
                        'labelTemplate': '${label}',
                        'listTemplate': '${name}', //'${type} - ${artigo}/${folha}',
                        'listGroup': 'parish',
                        'placeholder': 'Artigo/Folha...',
                        'ACL': 'GP_S_CART_10001',
                        'limit': 50,
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
            },
            search: {
                active: true,
                title: 'Lista de bens',
                label: 'Filtros',
                panel: {
                    show: false,
                    loaded: false,
                    allowExportData: true,
                    formatExportData: 'xls',
                    fieldGeometry: 'geometry_id',
                },
                acl: {
                    view: 'PIM_00004',
                    export: 'PIM_00038',
                },
                url: {
                    searchAll: `${codeAPI}/front/mp/search`,
                    getLists: `${codeAPI}/front/mp/search/lists`,
                    geomObject: `${codeAPI}/front/mp/object/geom/{id}`,
                    export: `${codeAPI}/front/mp/search/export`,
                    job: `${codeAPI}/front/mp/search/export/job/:id`,
                },
            },
            catalog: {
                acl: {
                    view: 'PIM_00015',
                },
            },
            identify: {
                acl: {
                    view: 'PIM_00016',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PIM_00035',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            mp_link_element: {
                active: true,
                title: "Nº de inventários",
                label: "inventários",
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PIM_00005',
                },
                url: {
                    searchElement: `${codeAPI}/front/mp/link/elements/search`,
                    getLink: `${codeAPI}/front/mp/link/elements/:id`,
                    getUpdate: `${codeAPI}/front/mp/link/elements`,
                }
            },
            data_patrimony: {
                model: 'print_inventories',
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PIM_00017',
                },
                url: {
                    urlObject: `${codeAPI}/front/mp/object/{id}`,
                    geomObject: `${codeAPI}/front/mp/object/geom/{id}`,
                }
            },
            print_data_patrimony: {
                model: 'print_inventories',
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PIM_00018',
                },
                url: {
                    create: `${codeAPI}/front/print/inventory`,
                    status: `${codeAPI}/front/print/inventory/job/:id`,
                }
            },
        },
         map: {
            loading: false,
            action: null,
            config: {
                layers: {
                },
                style: {

                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;